import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory, {
	PaginationProvider
} from 'react-bootstrap-table2-paginator';
import 'App.css';
import Spinner from 'Common/Spinner';
import { withFuncCompTracking } from 'Telemetry/telemetry.service';
import AmendContractTeamColumns from './AmendContractTeamColumns';

const AmendContractTeamTable = props => {
    let { contractTypes, keyField, apiCallCompleted, amendContractTeam, pageNo, total, pageSize, searchText, markingTeamId, key } = props;	
	const columns = AmendContractTeamColumns();

	let btnTeamExportDisable = amendContractTeam && amendContractTeam.length > 0 ? false : true;

	let setSelectRowAttributes = {
		mode: 'radio',
		clickToSelect: true,
		hideSelectColumn: true,
		selected: [0, markingTeamId],
		onSelect: props.onSelectTeamRow,
		classes: 'selected-row'
	};

	//_Customized Export.
	const ExportCSVButton = exportProps => {
		const handleClick = () => {
			props.getExportData(exportProps);
		};
		return (
			<div>
				<button
					className="react-bs-table-csv-btn btn btn-default btn-primary"
					disabled={btnTeamExportDisable}
					style={{ height: '35px', width: '150px' }}
					onClick={handleClick}
				>
					Export CSV
				</button>
			</div>
		);
	};
	return (
		<React.Fragment>
			<PaginationProvider
				pagination={paginationFactory({
					custom: true,
					totalSize: total,
					page: pageNo,
					sizePerPage: pageSize,
					showTotal: true,
					withFirstAndLast: true,
					alwaysShowAllBtns: true
				})}
				keyField={keyField}
				columns={columns}
				data={amendContractTeam}
				key={key}
			>
				{({ paginationProps, paginationTableProps }) => (
					<ToolkitProvider
						keyField={keyField}
						columns={columns}
						data={amendContractTeam}
						search={{ placeholder: 'Search...', defaultSearch: searchText }}
						exportCSV={{
							fileName: `contract_Management_${contractTypes.join('_')}.csv`,
							separator: ','
						}}
					>
						{toolkitProps => {
							return (
								<div className="container-fluid">
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
											flexWrap: 'wrap'
										}}
									>                                                                        
									</div>
									<BootstrapTable
										classes={'table tableStyle table-primary table-striped table-sm table-responsive-md'}
										{...toolkitProps.baseProps}
										{...paginationTableProps}
										remote={{
											pagination: true,
											search: true,
											sort: true
										}}
										onTableChange={props.onTeamTableChange}
										filter={filterFactory()}
										bootstrap4
										striped
										condensed
										hover
										size="sm"
										selectRow={setSelectRowAttributes}
										ignoreSinglePage
									/>
									{!apiCallCompleted && <Spinner />}
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
											flexWrap: 'wrap'
										}}
									>
										<ExportCSVButton {...toolkitProps.csvProps} />
									</div>
								</div>
							);
						}}
					</ToolkitProvider>
				)}
			</PaginationProvider>
		</React.Fragment>
	);
};

export default withFuncCompTracking('Amend Contract Team Table')(AmendContractTeamTable);
